import { action, computed, observable } from 'mobx';

export default class DataCrafterTemplateCommitDataModel {
    @observable
    exportedTemplateFileName: string;

    @observable
    modelMappings: { [key: string]: string };

    @observable
    inputPackageMappings: { [key: string]: string };

    @observable
    outputPackageMappings: { [key: string]: string };

    @computed
    get isValid() {
        const allMappingsSelected = (mappings: { [key: string]: string }) =>
            Object.values(mappings).every(value => Boolean(value));

        return (
            allMappingsSelected(this.inputPackageMappings) &&
            allMappingsSelected(this.outputPackageMappings) &&
            allMappingsSelected(this.modelMappings)
        );
    }

    constructor() {
        this.inputPackageMappings = {};
        this.outputPackageMappings = {};
        this.modelMappings = {};
    }

    @action.bound
    setModelMapping(sourceModelRole: string, targetModelId: string) {
        const newMappings = { ...this.modelMappings };
        newMappings[sourceModelRole] = targetModelId;
        this.modelMappings = newMappings;
    }

    @action.bound
    setInputPackageMapping(sourcePackageId: string, targetPackageId: string) {
        const newMappings = { ...this.inputPackageMappings };
        newMappings[sourcePackageId] = targetPackageId;
        this.inputPackageMappings = newMappings;
    }

    @action.bound
    setOutputPackageMapping(sourcePackageId: string, targetPackageId: string) {
        const newMappings = { ...this.outputPackageMappings };
        newMappings[sourcePackageId] = targetPackageId;
        this.outputPackageMappings = newMappings;
    }

    @action.bound
    setExportedTemplateFileName(fileName: string) {
        this.exportedTemplateFileName = fileName;
    }
}
